import { HARMONY_INTERNATIONAL_CALLBACK } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import { useSelectedCallerID } from '@rsos/reduxDataStore/src/features/emergencyCalls';
import { isInternationalNumber } from '@rsos/utils/internationalPhoneNumberUtils';

/**
 * Returns whether the current caller should be offered the International
 * Callback feature.
 *
 * Two conditions must both be true:
 * - The org has the `harmony_international_callback_0` capability.
 * - The active caller's number is international relative to the agency's
 *   configured country (resolved automatically via `configurePhoneUtils`,
 *   which is kept in sync by the agency info middleware).
 */
const useHasAccessToIntlCallback = () => {
  const callerID = useSelectedCallerID();
  const { hasCapability } =
    useHasCapability(HARMONY_INTERNATIONAL_CALLBACK) ?? {};
  const isIntl = isInternationalNumber(callerID);

  return !!hasCapability && isIntl;
};

export default useHasAccessToIntlCallback;
